<template>
  <div class="password-changed">
    <v-icon size="73"> $checkIcon </v-icon>
    <span class="mt-10 font-Medium-20">{{
      $t("authPage.passwordChanged.title")
    }}</span>
    <p class="font-Regular-14 mt-3 gray2--text">
      {{ $t("authPage.passwordChanged.description") }}
    </p>
    <v-btn
      to="/auth/login"
      color="primary"
      class="mt-10 py-5 px-16"
      @click="openCardModal"
    >
      {{ $t("authPage.passwordChanged.button") }}
    </v-btn>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.password-changed {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 90vh;
}
</style>
